import nuskin from './namespace.js';
import {storage} from '@nuskin/ns-util';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace nsSearchBarAdapter
 */
nuskin.site.PreferencesCookieService = function(){

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    var publicMethods = {
        getPreferences : function(){
            var preferences = null;
            var preferencesData = getStoredPreferences();

            preferences = new nuskin.site.Preferences(preferencesData);

            return preferences;
        },
        setPreferences : function(preferences){
            writePreferencesToStorage(preferences);
        },
        resetPreferencesCookie : function(){
            writePreferencesToStorage(null);
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredPreferences(){
        var preferences = null;
        if ($.cookie !== undefined){
            var cookieVal = storage(storage.metadata.NUSKIN_SITE);
            if (cookieVal !== null && cookieVal !== undefined) {
                var account = JSON.parse(cookieVal);
                if (account !== null && account !== undefined){
                    preferences = JSON.parse(cookieVal).preferences;
                }
            }
        }
        return preferences;
    }

    function writePreferencesToStorage(preferences){
        if ($.cookie !== undefined) {
            var options = {path: '/'};
            if (preferences !== null  && preferences instanceof nuskin.site.Preferences){
                storage(storage.metadata.NUSKIN_SITE, {preferences: preferences.toJSON()}, options);
            }
            else {
                storage(storage.metadata.NUSKIN_SITE, {preferences: preferences}, options);
            }
        }
    }

    return publicMethods;
}();

export default nuskin.site.PreferencesCookieService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/preferencesCookieService.js
// module id = 297
// module chunks = 0